import {
  ReactNode,
} from 'react';
import { useIntl } from 'react-intl';
import { ReCaptchaProvider } from 'next-recaptcha-v3';

export const RecaptchaContextProvider = ({ children }: { children: ReactNode }) => {
  const { locale } = useIntl();

  return (
    <ReCaptchaProvider
      language={locale}
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
    >
      {children}
    </ReCaptchaProvider>
  );
};

